import { useState } from 'react';
import { siteData } from '@/data/siteData';

export function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { href: '#home', label: 'Home' },
    { href: '#services', label: 'Services' },
    { href: '#obituaries', label: 'Obituaries' },
    { href: '#contact', label: 'Contact' },
  ];

  return (
    <header className="fixed top-0 w-full z-50 bg-white/95 backdrop-blur-md border-b border-brand-navy/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center cursor-pointer" onClick={() => window.scrollTo(0, 0)}>
            <img
              src="/images/logo.jpg"
              alt="Hess Funeral Services Logo"
              className="h-12 w-12 md:h-14 md:w-14"
            />
            <span className="ml-3 text-2xl font-serif font-bold text-brand-navy tracking-tight">
              Hess
            </span>
          </div>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-sm font-medium text-brand-navy/70 hover:text-brand-gold transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href={`https://wa.me/${siteData.whatsappPhone.replace('+', '')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 bg-brand-gold text-brand-navy rounded-full text-sm font-medium hover:opacity-90 transition-all"
            >
              WhatsApp Chat
            </a>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-brand-navy hover:text-brand-gold"
              aria-label="Toggle menu"
            >
              {isOpen ? (
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-brand-navy/10">
          <div className="px-4 pt-2 pb-6 space-y-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setIsOpen(false)}
                className="block text-sm font-medium text-brand-navy hover:text-brand-gold py-2"
              >
                {link.label}
              </a>
            ))}
            <a
              href={`https://wa.me/${siteData.whatsappPhone.replace('+', '')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="block text-sm font-medium text-brand-navy hover:text-brand-gold py-2"
            >
              WhatsApp Chat
            </a>
            <a
              href={siteData.whatsappChannel}
              target="_blank"
              rel="noopener noreferrer"
              className="block text-sm font-medium text-brand-navy/70 hover:text-brand-gold py-2 text-xs"
            >
              WhatsApp Channel
            </a>
            <div className="pt-4">
              <p className="text-xs text-brand-navy/50 mb-3 uppercase tracking-wider font-semibold">
                Contact
              </p>
              <p className="text-sm text-brand-navy">{siteData.locations[0].officePhone}</p>
              <p className="text-sm text-brand-navy">{siteData.email}</p>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}